import { Divider } from "@mui/material";

import type { WorkoutAnswer, WorkoutUser } from "../../api/workout-service";

import UserList from "../user/UserList";

export type WorkoutUsersBlockProps = {
    users: WorkoutUser[];
    answers?: WorkoutAnswer[];
    show?: boolean;
};

export default function WorkoutUsersBlock({ users, answers, show }: WorkoutUsersBlockProps) {
    if (!show) return <></>

    return <>
        <Divider style={ { marginTop: '50px' } }>Users</Divider>

        <UserList users={ users } answers={ answers }/>
    </>;
}
